import { SortUtil } from '@/utils/Sorting'

const category_sort = {
  KVG: 0,
  HOSP: 1,
  ADDITIONAL: 2,
  OTHER: 3,
}

function addSortedCategoriesToMap(personMap, categories) {
  for (let [key, value] of personMap) {
    value.diffProducts = Object.values(categories[key]).sort(SortUtil.sortByParam(item => category_sort[item.id]))
  }
}

function mergeProducts(existingProducts, newProducts) {
  return Object.assign({}, existingProducts, {
    products: Object.assign({}, existingProducts.products, newProducts),
  })
}

function mapPerson(personMap, person, mode) {
  const contractNumber = person.contractNumber
  const existingProducts = personMap.get(contractNumber)?.products || {}
  personMap.set(
    contractNumber,
    Object.assign({}, personMap.get(contractNumber), {
      age: person.age,
      personId: person.personId,
      contractNumber: person.contractNumber,
      personData: person.personData,
      products: mergeProducts(existingProducts, person.products.products), // Still needed for OvpProduct-Component
      selectedProducts: person.selectedProducts, // Still needed for OvpProduct-Component
      [mode]: {
        total: person.total,
      },
    })
  )
}

function addCategoryToList(currentCategories, contractNumber, category, mode) {
  if (!currentCategories[contractNumber]) {
    currentCategories[contractNumber] = {}
  }
  currentCategories[contractNumber][category.id] = Object.assign({}, currentCategories[contractNumber][category.id], {
    id: category.id,
    [mode]: category.products,
  })
  return currentCategories
}

// @TODO check whether this all should be moved to DiffBasket hook or remain split
export const DiffBasketUtil = {
  addCategoryToList,
  addSortedCategoriesToMap,
  mapPerson,
}
